var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcondocumentapprovedicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79159 1.91675C4.53742 1.91675 4.29366 2.01771 4.11394 2.19744C3.93422 2.37716 3.83325 2.62092 3.83325 2.87508V18.2084C3.83325 18.9709 4.13615 19.7022 4.67532 20.2413C5.21449 20.7805 5.94575 21.0834 6.70825 21.0834H16.2916C17.0541 21.0834 17.7853 20.7805 18.3245 20.2413C18.8637 19.7022 19.1666 18.9709 19.1666 18.2084V7.66675C19.1665 7.4126 19.0655 7.16889 18.8858 6.98921L14.0941 2.19754C13.9144 2.0178 13.6707 1.9168 13.4166 1.91675H4.79159ZM13.4166 4.23016L16.8532 7.66675H13.4166V4.23016ZM15.0525 13.136C15.227 12.9552 15.3236 12.7131 15.3214 12.4619C15.3193 12.2106 15.2185 11.9702 15.0408 11.7925C14.8631 11.6149 14.6227 11.5141 14.3715 11.5119C14.1202 11.5097 13.8781 11.6063 13.6974 11.7809L10.5416 14.9367L9.30246 13.6975C9.12172 13.523 8.87964 13.4264 8.62837 13.4286C8.3771 13.4307 8.13673 13.5315 7.95905 13.7092C7.78137 13.8869 7.68058 14.1273 7.6784 14.3785C7.67621 14.6298 7.77281 14.8719 7.94738 15.0526L9.86404 16.9693C10.0438 17.1489 10.2875 17.2499 10.5416 17.2499C10.7957 17.2499 11.0394 17.1489 11.2191 16.9693L15.0525 13.136Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcondocumentapprovedicon);
export default __webpack_public_path__ + "static/media/icondocumentapproved.icon.9cdbb7bac636e3b7c2a7e09d3c7e3c31.svg";
export { ForwardRef as ReactComponent };